import lightgallery from 'lightgallery'
import video from 'lightgallery/src/js/lg-video'

require('!style!css!sass!lightgallery/src/sass/lightgallery.scss');

$(function () {

    let indicator = function(index, number) {
        var html = "<div class='h1 center absolute bottom-0 full-width white'>"
        for (i = 0; i < number; i ++){
            if (i == index){
                html += "&#x25CB";
            } else {
                html += "&#x25CF"
            }
        }
        html += "</div>"
        return html;
    }

    $('[data-block="photos-or-videos-showcase-block"] .video-gallery').lightGallery({
        download: false,
        speed: 500,
        hideBarsDelay: 3000,
        preload: 2,
        counter: false,
        mousewheel: false,
        youtubePlayerParams: {
            modestbranding: 1,
            showinfo: 0,
            rel: 0,
            controls: 1
        },
    });

    $('[data-block="image-only-block"] .gallery').lightGallery({
        download: false,
        speed: 500,
        hideBarsDelay: 3000,
        preload: 2,
        counter: false,
        mousewheel: false,
    });
    // Inefficient no-scroll body
    // (was causing layout jitter due to scrollbar toggle)
    // for (var i = 0; i < galleries.length; i++){
    //     galleries[i].id = 'photoshowcase-' + [i];
    //     name = galleries[i].id;

    //     $('#' + name + '').on('onBeforeOpen.lg',function(event, index, fromTouch, fromThumb){
    //         $('body').addClass('no-overflow');
    //     });
    //     $('#' + name + '').on('onCloseAfter.lg',function(event, index, fromTouch, fromThumb){
    //      $('body').removeClass('no-overflow');
    //     });
    //     $('#' + name + '').on('onSlideItemLoad.lg',function(event, index){
    //        var size = $('.lg-inner').find('.lg-item').size();
    //         $('.lg-inner').find('.lg-item').eq(index).append(indicator(index, size));
    //     });
    // }


    $('#wechat-popup').lightGallery({
        download: false,
        speed: 500,
        hideBarsDelay: 3000,
        counter: false,
        mousewheel: false,
    });

    $('.content_popup').lightGallery({
            download: false,
            speed: 500,
            hideBarsDelay: 10000,
            preload: 2,
            counter: false,
            mousewheel: false,
            appendSubHtmlTo: '.lg-img-wrap',
            addClass: 'lg_content_popup',
    });
    $('.content_popup').on('onBeforeOpen.lg',function(event, index, fromTouch, fromThumb){
        $('body').addClass('no-overflow');
    });
    $('.content_popup').on('onCloseAfter.lg',function(event, index, fromTouch, fromThumb){
        $('body').removeClass('no-overflow');
    });
    $('.content_popup').on('onSlideItemLoad.lg',function(event, index){
        var size = $('.lg-inner').find('.lg-item').length;
        $('.lg-inner').find('.sub-wrapper').eq(index).append(indicator(index, size));
    });
    $( ".popup_content" ).click(function(e) {
        e.preventDefault();
        var goal =  $(this).attr('href'),
            page = 0;
        if (goal.indexOf('#') > -1){
            goal = goal.substring(0, goal.indexOf('#'));
            page = parseInt($(this).attr('href').substring($(this).attr('href').indexOf('#')+1))-1;
            if (page < 0){
                page = 0
            } else if (page > $('.' + goal + '.content_popup' ).find('a').length-1 ) {
                page = $('.' + goal + '.content_popup' ).find('a').length-1;
            }
        }
        $('.' + goal + '.content_popup' ).find('a').eq(page).click();
    });

    //Financial_Aid_Deadlines_Table_Block

    $('.js-finaid-deadline').each(function(){
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth()+1; //January is 0!
      var yy = 2000 + (today.getYear() - 100);
      var today = mm + "/" + dd + "/" + yy;
      var today = new Date(today);
      var testdate = new Date($(this).text().trim())
      if (testdate >= today) {
        $(this).parent().addClass('bold orange');
        return false;
      }
    });



    // Build something to close window on background click when on mobile device, but prevent it from closing when clicking on the image itself
    // $('#video-gallery').on('onAfterOpen.lg',function(event, index, fromTouch, fromThumb){
    //     $('.lg-inner').bind('click touchend', function () { $('#video-gallery').data('lightGallery').destroy(false); });
    // });
    // $('#video-gallery').on('onSlideItemLoad.lg',function(event, index, fromTouch, fromThumb){
    //     $('.lg-image').addClass('no-click');
    // });
});



// WEBPACK FOOTER //
// client/cms/gallery/bundle.js